module.exports = __webpack_public_path__ + "static/ppf-3-bc82f4753ca366f4db08e9f40635b64e.jpg";